<a (click)="onClick($event, refLink)"
   [ngClass]="{'link-invalid': refLink.invalid, 'link-internal': true}"
   [title]="refLink.invalid ? 'Link is invalid' : ''"
>
  {{ linkText }}
</a>
